module.exports = __webpack_public_path__ + "static/media/border-bottom.0e08af02.svg";